'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var _regeneratorRuntime = require('@babel/runtime/regenerator');
var cache = require('./utils/cache.js');
var probeCheck = require('./utils/probeCheck.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);

var PROBE_CACHE_KEY = 'probe';
var PROBE_CACHE_TTL = 1 * 60 * 1000;
/* dependencies example:
export const dependencies = [
  { name: 'bookinghub', url: bookingHubUrl },
  { name: 'TokenWS', url: tokenApi },
  {
    name: 'CrmApi',
    url: `${crmApiProxy}/customerapi/`,
    headers: { 'Ocp-Apim-Subscription-Key': apimKey },
  },
  { name: 'Ymer', url: `${ymer}/v1/attributeCollection/alias-login-1` },
];
*/

var probe = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(req, res, dependencies) {
    var cachedResult, result;
    return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            // We cache the results of the probe check for one minute, since Dynatrace calls
            // this endpoint like once a second, and we do not want to DDos our dependencies 🙄
            cachedResult = cache.get(PROBE_CACHE_KEY);

            if (!cachedResult) {
              _context.next = 5;
              break;
            }

            if ((cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.status) === 'Error') {
              res.status(500).json(cachedResult);
            } else {
              res.status(200).json(cachedResult);
            }

            return _context.abrupt("return");

          case 5:
            _context.next = 7;
            return probeCheck.probeCheck(dependencies);

          case 7:
            result = _context.sent;
            cache.set({
              name: PROBE_CACHE_KEY,
              data: result,
              ttl: PROBE_CACHE_TTL
            });

            if ((result === null || result === void 0 ? void 0 : result.status) === 'Error') {
              res.status(500).json(result);
            } else {
              res.status(200).json(result);
            }

            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            res.status(500).json({
              message: 'Internal Server Error'
            });

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 12]]);
  }));

  return function probe(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.probe = probe;
//# sourceMappingURL=probe.js.map
